/* neclintit 21 iul 2026 (v2): meniu HIBRID — hover simplu si generos + click.
   Sistemul de hover-intent al temei (safety-box, twitchy pe Windows) e scos din
   blocks/_header-menu.liquid; aici il inlocuim cu timere simple si deterministe,
   refolosind metodele PUBLICE ale componentei <header-menu> (activate/deactivate):
   - hover pe categorie: deschide dupa 80ms (nu clipoceste in trecere)
   - trecere peste alta categorie: comuta DOAR daca zabovesti 160ms pe ea
   - iesire din meniu (bara + panou): inchide cu gratie dupa 300ms
   - click pe titlu cand panoul e DESCHIS: navigheaza la pagina categoriei
   - touch: primul tap deschide, al doilea navigheaza; Escape/click afara inchid */
(function () {
  'use strict';

  var OPEN_MS = 80;
  var SWITCH_MS = 160;
  var CLOSE_MS = 300;

  function itemDeschis(menu) {
    return menu.querySelector('.menu-list__list-item > [ref="menuitem"][aria-expanded="true"]');
  }

  function inchide(menu) {
    var deschis = itemDeschis(menu);
    if (!deschis || typeof menu.deactivate !== 'function') return;
    var li = deschis.closest('.menu-list__list-item') || deschis;
    menu.deactivate({ target: li, relatedTarget: null });
  }

  function inchideToate(cuExceptia) {
    document.querySelectorAll('header-menu').forEach(function (menu) {
      if (menu !== cuExceptia) inchide(menu);
    });
  }

  function areSubmeniu(li) {
    return !!(li.querySelector('[ref="submenu[]"]') || li.slot === 'more' || li.slot === 'overflow');
  }

  function init(menu) {
    if (menu.dataset.ncClickMenu) return;
    menu.dataset.ncClickMenu = '2';

    var openTimer = null; // deschidere/comutare in asteptare
    var closeTimer = null; // inchidere cu gratie in asteptare

    function anuleazaOpen() {
      if (openTimer) {
        clearTimeout(openTimer);
        openTimer = null;
      }
    }
    function anuleazaClose() {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
    }

    // --- HOVER (doar mouse real; touch/synthetic nu intra aici) ---
    menu.addEventListener(
      'pointerenter',
      function (ev) {
        if (ev.pointerType !== 'mouse') return;
        anuleazaClose(); // ai reintrat in meniu: nu mai inchide
      },
      true
    );

    menu.addEventListener(
      'pointerleave',
      function (ev) {
        if (ev.pointerType !== 'mouse') return;
        // parasesti tot meniul (bara + panoul e copil in DOM): gratie, apoi inchide
        if (ev.target === menu) {
          anuleazaOpen();
          anuleazaClose();
          closeTimer = setTimeout(function () {
            closeTimer = null;
            inchide(menu);
          }, CLOSE_MS);
        }
      },
      true
    );

    // hover pe itemele de nivel 1
    menu.querySelectorAll('.menu-list__list-item').forEach(function (li) {
      li.addEventListener('pointerenter', function (ev) {
        if (ev.pointerType !== 'mouse') return;
        anuleazaClose();
        anuleazaOpen();

        var item = li.querySelector('[ref="menuitem"]');
        var eDeschisAcesta = item && item.getAttribute('aria-expanded') === 'true';
        if (eDeschisAcesta) return; // deja deschis: nimic de facut

        var existaAltulDeschis = !!itemDeschis(menu);
        if (!areSubmeniu(li)) {
          // link simplu: daca zabovesti pe el cu alt panou deschis, inchide panoul
          if (existaAltulDeschis) {
            openTimer = setTimeout(function () {
              openTimer = null;
              inchide(menu);
            }, SWITCH_MS);
          }
          return;
        }

        var dwell = existaAltulDeschis ? SWITCH_MS : OPEN_MS;
        openTimer = setTimeout(function () {
          openTimer = null;
          if (typeof menu.activate === 'function') menu.activate({ target: li });
        }, dwell);
      });

      li.addEventListener('pointerleave', function (ev) {
        if (ev.pointerType !== 'mouse') return;
        // ai plecat de pe item inainte sa expire dwell-ul: nu deschide/comuta
        anuleazaOpen();
      });
    });

    // --- CLICK / TAP ---
    menu.addEventListener(
      'click',
      function (ev) {
        if (!(ev.target instanceof Element)) return;
        // Cmd/Ctrl/Shift+click sau click de mijloc: lasa browserul (tab nou)
        if (ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.button !== 0) return;
        // click INAUNTRUL panoului (subcategorii, "Vezi tot"): navigare normala
        if (ev.target.closest('[ref="submenu[]"]')) return;

        var li = ev.target.closest('.menu-list__list-item');
        if (!li || !menu.contains(li)) return;
        if (!areSubmeniu(li)) return; // link simplu: navigheaza

        var item = li.querySelector('[ref="menuitem"]');
        var eDeschis = item && item.getAttribute('aria-expanded') === 'true';
        if (eDeschis) {
          // panoul e deja deschis (hover sau tap anterior): click = navigheaza
          return;
        }
        ev.preventDefault();
        ev.stopPropagation();
        anuleazaOpen();
        if (typeof menu.activate === 'function') menu.activate({ target: li });
      },
      true
    );
  }

  // click oriunde in afara meniului: inchide
  document.addEventListener('pointerdown', function (ev) {
    var inMeniu = ev.target instanceof Element && ev.target.closest('header-menu');
    if (!inMeniu) inchideToate(null);
  });

  // Escape: inchide
  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape') inchideToate(null);
  });

  function boot() {
    document.querySelectorAll('header-menu').forEach(init);
  }
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('header-menu').then(boot).catch(function () {});
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
